import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function NasljednoPravo() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Nasljedno pravo" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Nasljedno pravo</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Nasljedno pravo
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 5
              </p>
              <p>
                <strong>Uslov:</strong> Nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Cilj predmeta Nasljedno pravo je da student upozna sa osnovama
                materijalnopravnog nasljednog uređenja kao i sa ostavinskim
                postupkom. Očekuje se da student usvoji temeljna znanja i
                temeljne institute nasljednog prava i savlada osnovne vještine
                rješavanja problema iz nasljednog prava. Studenti će proučavati
                i sudsku praksu, stavove pravne nauke i uporednog prava iz
                oblasti nasljednog prava. Vodiće se računa da teorijska znanja
                budu primjenjiva u praksi, što će studentima omogućiti
                savladavanje vještina diobe nasljeđa, određivanje nasljednih
                redova, kruga nasljednika i njihovih nasljednih dijelova.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Studenti treba da budu u stanju da obrade sva pravna pitanja
                koja se postavljaju u vezi sa otvaranjem nasljeđa jednog lica te
                da budu u stanju da u stvarnom ili hipotetičkom slučaju mogu
                odrediti nasljednike, veličinu njihovih nasljednih dijelova i
                sastav zaostavštine, kao i riješiti eventualna procesna pitanja
                koja se s tim u vezi postavljaju. Takođe, nakon uspješno
                savladanog studijskog sadržaja predmeta, studenti će moći
                pravilno tumačiti propise koji uređuju materiju nasljednog
                prava, riješiti problem pravnih praznina, izraditi nacrte
                testamenta, nacrte notarskih zapisa, sadržaj podnesaka i drugih
                pravnih akata, odrediti koja su pravna pravila relevantna za
                rješavanje konkretnog slučaja te primijeniti pravna pravila na
                konkretne životne situacije.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Teorijska nastava obuhvata pojmove, izvore i osnovna načela
                nasljednog prava; pretpostavke za nasljeđivanje; zakonsko
                nasljeđivanje i nužni dio; testamentarno nasljeđivanje; ugovorno
                nasljeđivanje; nasljeđivačku izjavu; pojam, predmet i osnovna
                načela ostavinskog postupka; izvore i pretpostavke za
                nasljeđivanje; uračunavanje poklona i legata u nasljedni dio,
                odricanje nasljeđivanja, odricanje u korist određenog
                nasljednika, nemogućnost odricanja od nasljedstva, isporuku,
                tumačenje zaveštanja, nevažnost zaveštanja, opozivanje
                zaveštanja, izvršioca zaveštanja i registrar testamenta.
                Praktična nastava uključuje pisanje podnesaka, ugovor o
                doživotnom izdržavanju, pisanje istog u formi notarskog zapisa,
                pisanje ugovora o ustupanju i raspodjeli imovine za života,
                analizu primjera iz prakse, analizu prezentovanja slučajeva i
                debatu uz konsultovanje sudske prakse, studiju slučaja.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Nastava se izvodi kroz predavanja, diskusije, izrade samostalnih
                istraživačkih radova – seminarskih radova, upoznavanje sa
                sudskom praksom crnogorskih sudova (u sudu ili u okviru nastave
                na fakultetu) i analizu sudske prakse od strane studenata.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>2P + 1V</td>
                    <td>Pojam i načela nasljednog prava</td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>2P + 1V</td>
                    <td>Izvori i pretpostavke za nasljeđivanje</td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>2P + 1V</td>
                    <td>
                      Nasljeđivanje na osnovu zakona, zaostavština, prava koja
                      nisu predmet nasljeđivanja
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>2P + 1V</td>
                    <td>
                      Imperativno zakonsko nasljeđivanje, nužni nasljednici,
                      pojam i priroda prava na nužni dio. Praktična nastava:
                      Analiza primjera iz prakse
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>2P + 1V</td>
                    <td>
                      Uračunavanje poklona i legata u nasljedni dio, odricanje
                      nasljeđivanja, odricanje u korist određenog nasljednika,
                      nemogućnost odricanja od nasljedstva
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td></td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>2P + 1V</td>
                    <td>Pojam i pravna priroda zaveštanja</td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>2P + 1V</td>
                    <td>Forme zaveštanja</td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>2P + 1V</td>
                    <td>Sadržaj zaveštanja, zaveštajna sposobnost</td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>2P + 1V</td>
                    <td>
                      Isporuka, tumačenje zaveštanja, nevažnost zaveštanja,
                      opozivanje zaveštanja, izvršilac zaveštanja, registrar
                      testamenta. Praktična nastava: Pisanje različitih vrsta
                      testamenta i studija slučaja
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>2P + 1V</td>
                    <td>Ugovori nasljednog prava</td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td></td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>2P + 1V</td>
                    <td>Nasljednička zajednica</td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>2P + 1V</td>
                    <td>
                      Ostavinski postupak, šeme krvnog srodstva, obrasci
                      testamenta i ugovora
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>2P + 1V</td>
                    <td>
                      Zakon o nasljeđivanju. Praktična nastava: Pisanje
                      podnesaka - ugovor o doživotnom izdržavanju, pisanje istog
                      u formi notarskog zapisa, ugovor o ustupanju i raspodjeli
                      imovine za života
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td></td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td></td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td></td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 3č / 2.15h</td>
                            <td>Ukupno: 60h</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 2č / 1.3h</td>
                            <td>Nastava + završni ispit: 45h</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 1č / 0.45h</td>
                            <td>Priprema i ovjera semestra: 4h</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 11h</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default NasljednoPravo;
